import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import { Card } from 'primereact/card';
import { SpeedDial } from 'primereact/speeddial';
import { CONSTANT } from '../../../../utils/constants';
import ImageItem from '../../common/image/ImageItem';
import './Show.scss';
import styles from "../../cards.module.scss"

function ShowItem({ show, updateShow, deleteShow, manageImages, previewMode }) {
  const actions = [
    {
      label: 'Modifier',
      icon: 'pi pi-pencil',
      command: () => {
        updateShow();
      }
    },
    {
      label: 'Supprimer',
      icon: 'pi pi-trash',
      command: () => {
        deleteShow();
      }
    }
  ];

  const header = (
    <div >
      <ImageItem
        image={show.image}
        className={'h-[180px] object-cover'}
        showPlaceholder={previewMode}
      />
    </div>
  );

  const title = <div className={styles.title}>{show.title}</div>;

  const subtitle = (
    <div className={styles.tagList}>
      {show.properties.map((p) => (
        <Tag
          tag={{
            label: p.label,
            bgColor: p.type == "np_location" ? 'bg-purple-500' : 'bg-orange-700'
          }}
          rounded
        />
      ))}
      {show.length && (

        <Tag
          tag={{
            label: show.length,
            bgColor: 'bg-blue-900'
          }}
          rounded
        />
      )}
    </div>
  );

  return (
    <Card
      title={title}
      subTitle={subtitle}
      header={header}
      className={`${styles.eventCard} ${previewMode ? styles.eventCardPreview : ""}`}>
      <p className={styles.subtitle}>{show.subtitle}</p>
      {!previewMode && (
        <>
          <Button
            className="h-9 absolute bottom-5 left-5"
            label={`${show.images.length} image${show.images.length > 1 ? 's' : ''}`}
            severity="secondary"
            rounded
            outlined
            onClick={manageImages}
          />
          <SpeedDial
            key="show-deletion"
            className="absolute bottom-5 right-3 text-xs "
            buttonClassName={'!h-9 !w-9'}
            model={actions}
            direction="up"
            rotateAnimation={false}
            showIcon="pi pi-ellipsis-v"
            hideIcon="pi pi-times"
          />
        </>
      )}
    </Card>
  );
}

export default ShowItem;
